import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const STRATEGY_BASE = "/countingstrategies";
const buildUrl = (endpoint) => STRATEGY_BASE + endpoint;
const API_TAG = 'CountingStrategies'
const API_TAG_SINGLE = 'CountingStrategySingle'

const countingStrategySlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCountingStrategies: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getCountingStrategies', API_TAG)
        }),
        getCountingStrategy: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            // providesTags: (id) => [{ type: `CountingStrategyTemplateSingle`,id }]
            providesTags: (result, error, arg) => [{ type: API_TAG_SINGLE, id: arg }]
        }),
        updateCountingStrategy: builder.mutation({
            query: countingStrategyInfo => ({
                url: buildUrl(`/${countingStrategyInfo.id}`),
                method: 'PUT',
                body: countingStrategyInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: API_TAG_SINGLE, id: arg.id }],
        }),
        addCountingStrategy: builder.mutation({
            query: strategyInfo => ({
                url: buildUrl(`/add`),
                method: 'POST',
                body: strategyInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG}],
        }),
        completeCountingStrategy: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/complete`),
                method: 'PUT',
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: API_TAG_SINGLE, id: arg.id }],
        }),
        deleteCountingStrategy: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: API_TAG_SINGLE, id: arg.id }],
        }),
        getCountingStrategySteps: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/steps?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: API_TAG_SINGLE, id: arg.id }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getCountingStrategyProducts', API_TAG_SINGLE)
        }),
        exportCountingStrategySteps: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}/steps/export`),
                method: 'POST',
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const jsonData = await response.json();

                    // Export finished within the timeout, so it can be downloaded right away
                    if (jsonData.blobUrl) {
                        const a = document.createElement('a');
                        a.href = jsonData.blobUrl;
                        a.download = jsonData.fileName || `telling_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                        a.target = '_blank'; // Open in new tab as fallback
                        document.body.appendChild(a);
                        a.click();
                        a.remove();

                        return { success: true, message: jsonData.message, immediate: true };
                    }

                    // Still generating in the background, the user gets a notification when it is ready
                    return { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId };
                },
            }),
        }),
    })
});

export const {
    useGetCountingStrategiesQuery,
    useGetCountingStrategyQuery,
    useAddCountingStrategyMutation,
    useUpdateCountingStrategyMutation,
    useDeleteCountingStrategyMutation,
    useGetCountingStrategyStepsQuery,
    useCompleteCountingStrategyMutation,
    useExportCountingStrategyStepsMutation
  } = countingStrategySlice;
